import {
    BROWSER_SET_DIMENSTION
} from '../constants';

const defaultState = {
    innerWidth,
    innerHeight
};

export const browserSize = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case BROWSER_SET_DIMENSTION:
            return {
                ...state,
                ...payload,
            };
        default:
            return state;
    }
};
